import { Grid, Typography, Container } from "@mui/material";
import React from "react";
import SupportedPlatformCard from "../components/SupportedPlatformCard";
import { useContext, Context } from "../Context";
import Loading from "../components/Loading";
import MessageModal from "../components/MessageModal";
import { useNavigate } from "react-router-dom";
import { URL, origin } from "../config";
import { Helmet } from "react-helmet-async";

const platforms = ["Commbank", "Swyftx", "Selfwealth"];

export default function SupportedPlatforms() {
  const [userInfo, setUserInfo] = React.useState({});
  const { userName } = useContext(Context);
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [codeError, setCodeError] = React.useState();
  const navigate = useNavigate();

  React.useEffect(() => {
    fetch(`${URL}/user?` + new URLSearchParams({ username: userName }), {
      method: "GET",
      mode: "cors",
      credentials: "include",
      headers: {
        "content-type": "application/json",
        Origin: `${origin}`,
      },
    })
      .then(async (response) => {
        return {
          data: await response.json(),
          code: response.status,
        };
      })
      .then((data) => {
        if (data.code !== 200) {
          setCodeError(data.code);
          setError(data.data.message);
        } else {
          setUserInfo(data.data);
          setLoading(false);
          console.log(data);
        }
      });
  }, []);

  const closeAlert = () => {
    setError("");
  };

  function handleErrorPage(code) {
    navigate(`/${code}`);
  }

  return (
    <>
      <Helmet>
        <title>WealthWatch | services</title>
      </Helmet>
      {codeError ? (
        handleErrorPage(codeError)
      ) : loading ? (
        <Loading />
      ) : (
        <>
          <Typography
            variant="h3"
            color="primary.contrastText"
            sx={{ py: 1, textAlign: "center" }}
          >
            Supported Platforms
          </Typography>
          <Container
            maxWidth="md"
            sx={{
              py: 6,
              "@media (max-width: 75em)": {
                width: "80%",
              },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              container
              spacing={3}
            >
              {platforms.map((platform) => (
                <SupportedPlatformCard
                  key={platform}
                  platform={platform}
                  linked={userInfo.services[platform.toLowerCase()].isLinked}
                />
              ))}
            </Grid>
          </Container>
        </>
      )}
      <MessageModal
        severity="error"
        title="error"
        open={error ? true : false}
        onClose={closeAlert}
      >
        {error}
      </MessageModal>
    </>
  );
}
